import { MUTATIONS, useMutation } from "../../../../../../api";
import InlineEdit from "../../../../../../design-system/components/InlineEdit/InlineEdit.jsx";

function GroupNameEdit({ workshopId, smallTeamId, groupName }) {
  const [doUpdateSmallTeamInfo] = useMutation(MUTATIONS.updateSmallTeamInfo);

  function handleBlur(name) {
    if (name.length < 2) {
      throw new Error(
        "Gruppenname ist zu kurz. Der Name muss mindestens zwei Zeichen haben.",
      );
    }

    if (name.length > 64) {
      throw new Error(
        "Gruppenname ist zu lang. Der Name darf nicht länger als 64 Zeichen sein.",
      );
    }

    if (!/^[ -~]*$/.test(name)) {
      throw new Error(
        "Diese Eingabe ist nicht zulässig. Verwende bitte keine Sonderzeichen.",
      );
    }

    return doUpdateSmallTeamInfo({ workshopId, smallTeamId, name });
  }

  return (
    <InlineEdit
      name="group name"
      id={`${smallTeamId}-group-name`}
      value={groupName}
      onBlur={handleBlur}
    />
  );
}

export default GroupNameEdit;
